import { dataProvider } from '../providers'

export default {
  lang: 'es',
  title: 'CMS LaLiga',
  dataProvider,
}
